module.exports = __webpack_public_path__ + "img/1.cc6bb425.png";